const state = {
  isLoading: false,
};

const mutations = {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  startLoading({ commit, dispatch }) {
    commit("setIsLoading", true);
  },

  endLoading({ commit, dispatch }) {
    commit("setIsLoading", false);
  },
};

const getters = {
  isLoading: (state) => {
    return state.isLoading;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
